<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="date"
        :label="label"
        :prepend-icon="icon"
        readonly
        clearable
        v-on="on"
        @change="$emit('date', date)"
      ></v-text-field>
    </template>
    <v-date-picker
      no-title
      v-model="date"
      @input="menu = false"
    ></v-date-picker>
  </v-menu>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      default: 'Fecha'
    },
    icon: {
      type: String,
      default: 'event'
    },
    default: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      date: '',
      menu: false
    }
  },
  mounted() {
    this.default ? (this.date = this.default) : (this.date = '')
  }
}
</script>